import { render } from "./AttendanceLogsDetail.vue?vue&type=template&id=0a27cd9c"
import script from "./AttendanceLogsDetail.vue?vue&type=script&lang=js"
export * from "./AttendanceLogsDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\Cigl-Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__